import React from "react";
import { Link } from "react-router-dom";
import Header from "./Front/Header";
import Footer from "./Front/Footer";
import "./styles/Wellness.css";
import "../styles/global.css";

const programs = [
  {
    title: "Daily Vitality Plan",
    description: "A balanced wellness program designed for everyday energy, digestion support, and emotional calm.",
    icon: "fa-leaf",
  },
  {
    title: "Stress Repair Routine",
    description: "Herbal recommendations, breathing exercises, and rituals to restore focus and resilience.",
    icon: "fa-spa",
  },
  {
    title: "Immune Harmony Kit",
    description: "Natural formulations curated to support immunity and keep you feeling strong all season long.",
    icon: "fa-shield-heart",
  },
];

const benefits = [
  {
    title: "Nature-led formulations",
    text: "Every product uses time-tested herbal ingredients blended with modern wellness science.",
    icon: "fa-seedling",
  },
  {
    title: "Clinically inspired guidance",
    text: "Our plans are informed by Ayurveda, nutrition, and daily lifestyle practices for real results.",
    icon: "fa-user-doctor",
  },
  {
    title: "Pure, safe, and transparent",
    text: "Clean ingredients, no hidden additives, and complete clarity across every label.",
    icon: "fa-flask",
  },
  {
    title: "Support for body and mind",
    text: "From digestive balance to restful sleep, our wellness concepts address your whole wellbeing.",
    icon: "fa-heart-pulse",
  },
];

const statistics = [
  { value: "25+", label: "Years", icon: "fa-award" },
  { value: "6L", label: "Patients", icon: "fa-users" },
  { value: "18+", label: "Branches", icon: "fa-map-location-dot" },
  { value: "450+", label: "Formulas", icon: "fa-mortar-pestle" },
];

export default function Wellness() {
  return (
    <div className="hc-home wl-page">
      <Header />

      {/* ═══════════════ BREADCRUMB ═══════════════ */}
      <section className="wl-breadcrumb">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Wellness</li>
            </ol>
          </nav>
        </div>
      </section>

      {/* ═══════════════ HERO ═══════════════ */}
      <section className="wl-hero">
        <div className="wl-hero-orb wl-hero-orb-1" aria-hidden="true" />
        <div className="wl-hero-orb wl-hero-orb-2" aria-hidden="true" />
        <div className="container wl-hero-inner">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <span className="wl-hero-badge"><i className="fa-solid fa-spa" /> Wellness, naturally powered</span>
              <h1 className="wl-hero-title">Your wellbeing journey starts with simplicity, strength, and serenity.</h1>
              <p className="wl-hero-text">Discover wellness rituals, nutrient-rich blends, and everyday self-care practices created with your natural rhythm in mind. This page is your welcome space for calm, health, and holistic balance.</p>
              <div className="d-flex flex-wrap gap-3 mt-4">
                <Link to="/contact" className="wl-btn-light">Talk to a specialist <i className="fa-solid fa-arrow-right" /></Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="wl-hero-cards">
                {benefits.slice(0, 3).map((item, index) => (
                  <div key={index} className="wl-hero-card">
                    <span className="wl-hero-card-icon"><i className={`fa-solid ${item.icon}`} /></span>
                    <div>
                      <strong>{item.title}</strong>
                      <p>{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════ PROGRAMS ═══════════════ */}
      <section className="section-padding">
        <div className="container">
          <div className="hc-section-head">
            <div>
              <span className="hc-kicker">Guided Care</span>
              <h2 className="hc-h2">Wellness programs crafted for <span>modern life</span></h2>
            </div>
          </div>
          <p className="wl-section-sub">Designed to fit busy days while preserving the restorative power of tradition, every program helps you move toward sustained wellbeing.</p>
          <div className="row g-4">
            {programs.map((program, index) => (
              <div className="col-md-4" key={index}>
                <div className="wl-card">
                  <span className="wl-card-icon"><i className={`fa-solid ${program.icon}`} /></span>
                  <h3 className="wl-card-heading">{program.title}</h3>
                  <p className="wl-card-text">{program.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ WHY IT WORKS ═══════════════ */}
      <section className="section-padding wl-section-tint">
        <div className="container">
          <div className="hc-section-head">
            <div>
              <span className="hc-kicker">Our Difference</span>
              <h2 className="hc-h2">Why our wellness <span>approach works</span></h2>
            </div>
          </div>
          <p className="wl-section-sub">Balanced, gentle, and effective principles rooted in herbal wellness and mindful wellbeing.</p>
          <div className="row g-4">
            {benefits.map((item, index) => (
              <div className="col-md-6" key={index}>
                <div className="wl-card wl-card-row">
                  <span className="wl-card-icon"><i className={`fa-solid ${item.icon}`} /></span>
                  <div>
                    <h3 className="wl-card-heading">{item.title}</h3>
                    <p className="wl-card-text">{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ STATS ═══════════════ */}
      <section className="section-padding">
        <div className="container">
          <div className="row gy-4">
            {statistics.map((stat, index) => (
              <div className="col-6 col-md-3" key={index}>
                <div className="wl-stat">
                  <span className="wl-stat-icon"><i className={`fa-solid ${stat.icon}`} /></span>
                  <div className="wl-stat-value">{stat.value}</div>
                  <div className="wl-stat-label">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ FINAL CTA ═══════════════ */}
      <section className="section-padding pt-0">
        <div className="container">
          <div className="wl-cta">
            <div className="wl-cta-orb" aria-hidden="true" />
            <div className="wl-cta-content">
              <h2 className="wl-cta-title">Ready to make wellness simple and supportive?</h2>
              <p className="wl-cta-text">Start with a personalized routine, expert herbal care, and a plan that fits your lifestyle. We make it easy to feel more grounded every day.</p>
              <div className="mt-4">
                <Link to="/contact" className="wl-btn-light">Book a wellness consult <i className="fa-solid fa-arrow-right" /></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}